<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap mb-2">
      <b-form
        class="d-flex align-items-center flex-sm-nowrap flex-wrap"
        @submit.prevent="onSearch"
      >
        <b-form-input v-model="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 mt-50" type="submit">
          جستجو
        </b-button>
      </b-form>
    </div>
    <data-table :fields="fields" :items="penalties" :loading="loading">
      <template #id="{ data }">
        {{ data.item.id }}
      </template>

      <template #created_at="{ data }">
        {{ calcDate(data.item.created_at) || "-" }}
      </template>
      <template #payed_at="{ data }">
        {{ calcDate(data.item.payed_at) || "-" }}
      </template>
      <template #amount="{ data }">
        <small class="text-success"
          >{{ numberWithCommas(data.item.amount) }} تومان</small
        >
      </template>
      <template #rebate="{ data }">
        <small class="text-danger"
          >{{ numberWithCommas(data.item.rebate) }} تومان
        </small>
      </template>
      <template #detail="{ data }">
        <div>
          <div>دوره : {{ data.item.course.name }}</div>
          <div class="my-50">جلسه : {{ data.item.session.name }}</div>
          <div>تمرین : {{ data.item.exercise.title }}</div>
        </div>
      </template>
      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 0
              ? 'info'
              : data.item.status == 1
              ? 'success'
              : 'warning'
          "
          >{{
            data.item.status == 0
              ? "در انتظار پرداخت"
              : data.item.status == 1
              ? "پرداخت شده"
              : "بخشیده شده"
          }}
        </b-badge>
      </template>
      <template #actions="{ data }">
        <b-button
          size="sm"
          v-if="data.item.status == 0"
          variant="flat-success"
          @click="checkout(data.item)"
          >پرداخت</b-button
        >
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>

    <loader :loading="loader" />
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@core/components/loader/Loader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import qs from "qs";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormCheckbox,
    BModal,
    BForm,
    BFormInput,
    Loader,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      required,
      penalties: [],
      search: "",
      loading: false,
      url: "/panel/penalties",
      currentPage: 1,
      choosenPage: 1,
      pagination: {},
      visible: false,
      loader: false,
      penalty: {},
      rebate: "",
      fields: [
        { key: "id", label: "شناسه" },
        { key: "created_at", label: "تاریخ جریمه" },
        { key: "amount", label: "مبلغ جریمه" },
        { key: "rebate", label: "مبلغ تخفیف" },
        { key: "detail", label: "شرح" },
        { key: "payed_at", label: "تاریخ پرداخت" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.getPenalties();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: this.$route.params.id ? "user-penalties" : "profile-penalties",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: this.$route.params.id ? "user-penalties" : "profile-penalties",
        });
      }
    },
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData;
    },
  },
  async created() {
    if (this.userData.has_penalties) {
      this.$swal({
        icon: "warning",
        text: "برای شما جریمه جدید صادر شده است.",
        showCancelButton: false,
        showConfirmButton: false,
        buttonsStyling: false,
      });
    }

    if (this.$route.query && this.$route.query.status) {
      await Object.keys(this.penaltiestatus).map((key) => {
        this.penaltiestatus[key] = this.$route.query[key];
      });
      this.visible = true;
    }
  },

  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: this.$route.params.id ? "user-penalties" : "profile-penalties",
          query: {
            key: this.search,
          },
        });
      }
    },
    async checkout(item) {
      this.loader = true;
      try {
        const { data } = await this.$http.post("/panel/invoices", {
          items: [
            {
              model: {
                id: item.id,
                type: "penalty",
              },
            },
          ],
        });
        this.loader = false;

        this.$router.push({
          name: "checkout",
          query: {
            invoice_id: data.data.id,
          },
        });
      } catch (err) {
        this.loader = false;
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `مشکلی پیش آمده است.`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },

    async getPenalties() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: ["transactions", "exercise", "course", "session"],
        };
        if (this.$route.params.id) {
          params.filters = {
            user_id: this.$route.params.id,
          };
        }
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.penalties = data.data.penalties;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
